import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import getDerivedFromMeasurementsConfig from 'Components/Worksheets/MoistureContentWorksheet/derivedFromMeasurementsConfig';
import qestIds from '../../../QestIds';
import getMeasuredUsingConfig from '../../measuredUsingConfig';
import getLabelConfig from './labelConfig';

/**
 * Additional arguments to customise the returned config object
 * of a BS moisture content test
 */
export type BsEnIsoMoistureContentGetConfigFunctionArgs = {
  /**
   * Overrides the term "Material" in field labels
   */
  materialLabelOverride?: string;
};

const getConfig = (
  prefix: string,
  { materialLabelOverride = undefined }: BsEnIsoMoistureContentGetConfigFunctionArgs = {}
) =>
  mergeConfig(
    {
      [`${prefix}.Equipment.DryingTemperature`]: { uom: '°C', format: { nearest: 1 } },
      [`${prefix}.Preparation.SaltContentGl`]: { uom: 'g/L', format: { nearest: 1 } },
      [`${prefix}.Preparation.FluidDensity`]: { uom: 'Mg/m³', format: { nearest: 0.001 } },
      [`${prefix}.Preparation.SaltContentPpt`]: { uom: 'ppt', format: { nearest: 1 } },
      [`${prefix}.Results.FluidContent`]: { format: { nearest: 0.1 } },
      [`${prefix}.DryingTray.DryMassReadings.DryingTime`]: { uom: 'h', format: { nearest: 0.01 } },
      [`${prefix}.ImagesAndRemarks.Remarks`]: { maxLength: 255 },
      [`${prefix}.ImagesAndRemarks.InternalRemarks`]: { maxLength: 255 },
      ...getMoistureContentPercent(`${prefix}.Results.MoistureContentPercent`),
    },
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    getLabelConfig(prefix, materialLabelOverride),
    {
      [`${prefix}.Equipment.Balance`]: { defaultReadability: 0.01, defaultUom: 'g' },
      [`${prefix}.Equipment.DryMassBalance`]: { defaultReadability: 0.01, defaultUom: 'g' },
    }
  );

const getMoistureContentPercent = (name: string) => ({
  [`${name}`]: { format: { nearest: 0.1 }, label: 'Water Content (%)' },
});

export { getConfig, getMoistureContentPercent };

export default {
  [qestIds.moistureContent.BS_EN_ISO_17892_1.rev2014]: getConfig,
};
